// const IS_LOGGING = (state, data) => {
// 	state.is_logging = data;
// };
export default {
    // IS_LOGGING
};
